/* cc-lang-switcher.js — remembers the visitor's explicit blog-language
   choice (localStorage cc:lang) and honors it on future visits: landing
   on a twinned page in the other language hops to the twin. Crawlers
   carry no localStorage, so SEO is untouched; first-time visitors are
   never redirected. Also closes the footer dropdown on outside click. */
(() => {
  const KEY = 'cc:lang';

  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[data-cc-lang]');
    if (a) {
      try {
        localStorage.setItem(KEY, a.dataset.ccLang);
      } catch (err) {
        /* private mode — memory off, links still work */
      }
      return;
    }
    document.querySelectorAll('details.cc-lang-switcher[open]').forEach((d) => {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });

  const el = document.querySelector('[data-cc-lang-current]');
  if (!el) return;
  const current = el.dataset.ccLangCurrent;
  const twin = el.dataset.ccLangTwin;
  let pref = null;
  try {
    pref = localStorage.getItem(KEY);
  } catch (err) {
    /* ignore */
  }
  if (pref && twin && pref !== current) location.replace(twin);
})();
